import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { CommonModelResponse, Transaction } from '../../models';
import { JwtHelperService } from '@auth0/angular-jwt';
@Injectable()
export class AuthenticateService {
    private redirectUrl = '';
    private loginUrl = '/booking-process/disclaimer';
    private jwtHelper: JwtHelperService = new JwtHelperService();
    private data: Transaction
    constructor(private http: HttpClient) {
    }    

    private checkTranactionExpires(data: Transaction, now: Date): boolean {
        if (data.ExpiresOn) {
            var currentDate = new Date(now);            
            var expireDate = new Date(data.ExpiresOn);
            if (expireDate >= currentDate) {
                return true;
            } else {
                this.clearStorage();
                return false;
            }
        }
        return false;
    }

    public getTransactionInfo(): Transaction {
        if (sessionStorage.getItem('SToken') && sessionStorage.getItem('SToken') !== '') {
            const data: Transaction = this.jwtHelper.decodeToken(sessionStorage.getItem('SToken'));
            return data;
        }
        return null;
    }

    public checkBrowserTransactionInfo(): boolean {
        if (localStorage.getItem('AToken') && localStorage.getItem('AToken') !== '') {
            return true;
        }
        return false;
    }

    public getTransactionExpireSeconds(utcNow: Date): number {
        if (sessionStorage.getItem('SToken') && sessionStorage.getItem('SToken') !== '') {
            const data: Transaction = this.jwtHelper.decodeToken(sessionStorage.getItem('SToken'));
            if (this.checkTranactionExpires(data, utcNow)) {
                var now = new Date(utcNow);
                var expireDate = new Date(data.ExpiresOn);
                var dif = expireDate.getTime() - now.getTime();
                var Seconds_from_T1_to_T2 = dif / 1000;
                var Seconds_Between_Dates = Math.abs(Seconds_from_T1_to_T2);
                return Seconds_Between_Dates;
            }
            return null;
        }
        return null;
    }

    public clearStorage() {
        localStorage.clear();
        sessionStorage.clear();
    }

    public setStorage(token: string) {
        localStorage.setItem('AToken', token);
        sessionStorage.setItem('SToken', token);
    }

    public getRedirectUrl(): string {
        return this.redirectUrl;
    }
    public setRedirectUrl(url: string): void {
        this.redirectUrl = url;
    }
    public getLoginUrl(): string {
        return this.loginUrl;
    }


}
